import { render } from "./field_settings.vue?vue&type=template&id=365e3ced"
import script from "./field_settings.vue?vue&type=script&lang=js"
export * from "./field_settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__